import React, { Component } from "react";
import Input from "../common/Input";
import close from "../assets/close.svg";
import { NavLink } from "react-router-dom";
import BackArrow from "../common/BackArrow";
import API from "../common/Api";
import { connect } from "react-redux";

const mapStateToProps = (state) => ({
  headers: state.headers(),
});

export default connect(mapStateToProps)(
  class passwordSettings extends Component {
    state = {
      errors: {},
    };
    save = (ev) => {
      ev.preventDefault();
      this.setState({ loading: true, errors: {} });
      const loaded = () => this.setState({ loading: false });
      const form = ev.currentTarget;
      const body = {
        old_password: form.old_password.value,
        new_password: form.new_password.value,
        new_password_confirmation: form.new_password_confirmation.value,
      };
      API.put("profile/password", body, {
        headers: this.props.headers,
      }).then(
        ({ data }) => {
          loaded();
          if (data.success) {
            // form.reset()
            window.$.notify("Password updated successfully", "success-alert");
          }
        },
        ({ response }) => {
          loaded();
          const data = response.data;
          const errorsArray = data.errors;
          if (errorsArray) {
            let errors = {};
            errorsArray.map((error) => {
              errors = Object.assign({}, errors, {
                [error.field]: error.message,
              });
            });
            this.setState({ errors });
          }
        }
      );
    };
    render() {
      return (
        <div className="dsk-modal-rapper">
          <NavLink className="absolute-bg" to="/profile/settings"></NavLink>
          <div className="dsk-modal profile-settings-page">
            <NavLink className="close-btn wrapper dsk" to="/profile/settings">
              <img src={close} alt="" srcSet="" />
            </NavLink>
            <div className="form_step form-page">
              <h1 className="form-title flex center">
                <div className="mbl">
                  <BackArrow />
                </div>
                Change password
              </h1>
              <div className="form-container card no-grid">
                <form onSubmit={this.save}>
                  <div>
                    <Input
                      label="old password"
                      name="old_password"
                      placeholder="Enter old password here"
                      type="password"
                      error={this.state.errors.old_password}
                      required
                    />
                    <Input
                      label="new password"
                      type="password"
                      name="new_password"
                      placeholder="Enter new password here"
                      error={this.state.errors.new_password}
                      required
                    />
                    <Input
                      label="confirm new password"
                      type="password"
                      name="new_password_confirmation"
                      placeholder="Confirm new password here"
                      error={this.state.errors.new_password_confirmation}
                      required
                    />
                    <div className="flex center space-btw">
                      <button
                        className={`default ${
                          this.state.loading ? "loading" : ""
                        }`}
                      >
                        Save Changes
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
);
